import { Link } from 'react-router-dom';
import { Seo, SITEMAP_ENTRIES, type SitemapEntry } from '../../core/seo';

const GROUP_LABELS: Record<string, string> = {
  main: 'Main',
  info: 'Info & How-to',
  legal: 'Legal & Policies',
  discovery: 'Discovery',
};

export default function Sitemap() {
  const byGroup = SITEMAP_ENTRIES.reduce<Record<string, SitemapEntry[]>>(
    (acc: Record<string, SitemapEntry[]>, entry: SitemapEntry) => {
      const group = entry.group || 'main';
      if (!acc[group]) acc[group] = [];
      acc[group].push(entry);
      return acc;
    },
    {}
  );

  const groupOrder = ['main', 'info', 'legal', 'discovery'];

  return (
    <div className="min-h-screen bg-white text-[#284F60] py-12 px-6">
      <Seo
        title="Sitemap"
        description="Browse all pages on HirePanther: home, services, how it works, about, contact, and legal policies."
        canonicalPath="/sitemap"
      />
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Sitemap</h1>
        <p className="text-gray-600 mb-10">
          A list of the main pages on HirePanther. Use this page to find what
          you need quickly.
        </p>

        {groupOrder.map((groupKey) => {
          const entries = byGroup[groupKey];
          if (!entries?.length) return null;
          const label = GROUP_LABELS[groupKey] ?? groupKey;

          return (
            <section key={groupKey} className="mb-10">
              <h2 className="text-xl font-semibold text-[#2D617A] mb-4 border-b border-gray-200 pb-2">
                {label}
              </h2>
              <ul className="list-none space-y-2">
                {entries.map((entry: SitemapEntry) => (
                  <li key={entry.path}>
                    <Link
                      to={entry.path}
                      className="text-primary hover:underline"
                    >
                      {entry.label ?? entry.path}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
